/** m:ss.cc — как в аниматике (сотые секунды из миллисекунд). */
export function formatMs(ms: number): string {
  const totalSec = Math.floor(ms / 1000)
  const m = Math.floor(totalSec / 60)
  const s = totalSec % 60
  const frac = Math.floor((ms % 1000) / 100)
  return `${m}:${String(s).padStart(2, "0")}.${frac}`
}
